import React from 'react';
import { styled } from '@mui/material/styles';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { FormHelperText, TextareaAutosize } from '@mui/material';

const CustomTextAreaWrapper = styled('div')(({ theme }) => ({
  '.error-ql-editor': {
    border: '1px solid #ff2c2c !important',
    borderRadius: `${theme.shape.borderRadius}px !important`,
  },
  '.ql-container': {
    minHeight: '150px',
    fontSize: '0.9rem',
    borderRadius: `0 0 ${theme.shape.borderRadius}px ${theme.shape.borderRadius}px`,
    // '&:hover': {
    //   border: '1px solid #365f73',
    // },
    // '&:focus-visible': {
    //   outline: '1px solid red',
    // },
    
  },
  '.ql-editor': {
    padding: theme.spacing(1),
    minHeight: '120px',
  },
  '.ql-toolbar': {
    borderRadius: `${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0 0`,
  },
}));

const CustomTextArea = (props) => {
  
  return (
    <CustomTextAreaWrapper 
      
    >
      {/* <ReactQuill {...props} /> */}
      <TextareaAutosize
        aria-label="minimum height"
        minRows={8}
        placeholder={props.placeholder}
        {...props}
        style={{ width: props.width, border: '1px solid #e0e0e0', borderRadius: '7px', padding: '8px'
        }}
        
        id={props.id}
        name={props.name}
        value={props.value}
        onChange={(e) => props.onChange(e.target.value)}
        className={props.error ? 'error-ql-editor' : ''}
      />
      {props.error && (
        
        <FormHelperText error id="standard-weight-helper-text-email-login">
            {' '}
            {props.helpertext}
        </FormHelperText>
      )}
    </CustomTextAreaWrapper>
  );
};

export default CustomTextArea;
